import { Log, apiRequest, Paginacion } from '@ext/utils';
export * from './Chat.types';
import { IChat } from './Chat.lib';
import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';

export class Chat extends IChat
{

    public static async create( id: number ): Promise<Chat>
    {
        let o = new Chat();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/mensajeria';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Chat>; Error?: boolean; }>
    {

        let a: Array<Chat> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/mensajeria` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Chat( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async CargarMensajes( pagina: number = 1 ): Promise<Mensaje[]>
    {
        try
        {

            if ( this.Existe )
            {
                let e = await Mensaje.find( { chat: this.Id, limit: 50, page: pagina } );
                if ( e.Items.hasRows() )
                {
                    return e.Items.sort( ( a, b ) => a.Fecha.valueOf() - b.Fecha.valueOf() )
                }
            }
        } catch ( e )
        {
            Log( e );
        }

        return [];
    }

    public async CargarMasMensajes( ultimo: Mensaje ): Promise<Mensaje[]>
    {
        try
        {

            if ( this.Existe )
            {
                let e = await Mensaje.find( { chat: this.Id, limit: 5, fecha: ultimo.Fecha.toSQL() } );
                if ( e.Items.hasRows() )
                {
                    return e.Items.sort( ( a, b ) => a.Fecha.valueOf() - b.Fecha.valueOf() )
                }
            }
        } catch ( e )
        {
            Log( e );
        }

        return [];
    }


    public async RecargarUltimoMensaje( x: any )
    {
        this.UltimoMensaje = new Mensaje(x);
    }

    public CantidadDisponible: number = 0;

    public get PermiteEnviar ()
    {
        return this.CantidadDisponible === -1 || this.CantidadDisponible > 0;
    }
    
    public async ObtenerCantidadDisponible ()
    {
        const data = await Mensaje.ObtenerCantidadDisponible( this.Pack, this.Cuenta );
        this.CantidadDisponible = data?.disponible || 0;
    }

}